export default function useModal(props, context) {
    function closeModal() {
        context.emit('input', false);
    }

    return { closeModal };
}
